import _ from 'lodash';
import { MutationTree } from 'vuex';
import { FiltersSimulation, FiltersSimulationState } from '@/models/states/filters-state.model';

export const mutations: MutationTree<FiltersSimulationState> = {
  onUpdateFilters(state, payload: FiltersSimulation) {
    state.filters = _.extend({}, state.filters, payload);
  },
};
